import React, {useEffect, useState} from "react"; 
import { useSelector } from 'react-redux'; 
import {
  Box, 
  Grid, 
  Typography,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  Checkbox,
  MenuItem
} from "@mui/material";
import RegisterStyles from "../../assets/css/register.styles"; 
import { AddCircle, Cancel  } from "@mui/icons-material";
import { GeneralStyles } from "../../assets/css/general.styles";
import CustomLabeledTextField from "../../components/customTextField/customLabeledTextField";  
import CustomLabeledSelect from "../../components/customSelect/customLabeledSelect";   
import theme from "../../themes/index.en";
import { ValidatableComponent } from "./validatableComponent"; 
import { RegisterTouched } from "./registerTouched";
import { InvestorModel } from "../../models/models/investorModel";
import CustomIcon from "../../components/customIcon/customIcon";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { RootState } from "../../store/store";
import { getBeneficiaryRelationship } from "../../reducers/lookupReducer";
import { LookupEnum } from "../../constants/enums";
import GridStyles from "../../assets/css/grid.styles";
import { InvestorBankDetailBeneficiaryModel } from "../../models/models/investorBankDetailBeneficiaryModel";
import { validateKuwaitIBAN } from "../../helpers/useCheckIBANHelpers";
import { getBanks } from "../../reducers/bankReducer";
const BankDetails: ValidatableComponent = ({
  formData,
  setFormData,
  touched,
  setTouched,
  setIbanIdentifier,
  ibanIdentifier,
  validateBeneficiaries,
  t,
  isRTL
}) => {  
  const dispatch = useAppDispatch();   

  const beneficiaryRelationshipList = useSelector((state: RootState) => state.lookup.beneficiaryRelationship);
  const banksList = useSelector((state: RootState) => state.bank.banks);
  
  useEffect(() => { 
    dispatch(getBeneficiaryRelationship({ lookupId: LookupEnum.BeneficiaryRelationship }));
    dispatch(getBanks());
  }, []); 

  useEffect(() => { 
   if(formData.bankDetails.kuwaitiBankId && Array.isArray(banksList.data)){
    const selectedBank = banksList.data.find(
      (item: any) => item.id === formData.bankDetails.kuwaitiBankId
    );
    setIbanIdentifier(selectedBank?.ibanidentifier)
    if (formData.bankDetails.iban.trim() !== "" && !validateKuwaitIBAN(formData.bankDetails.iban, selectedBank?.ibanidentifier)) { 
          setTouched((prevData) => ({
          ...prevData,
          iban: true,
          }));
    }
  }
  }, [formData.bankDetails.kuwaitiBankId]); 
  
  const handleRadioClick = (value: string) => {
    const flag = 
      formData.bankDetails.isKuwaitiBankAccount === true && value === "yes" ? null
    : formData.bankDetails.isKuwaitiBankAccount === true && value === "yes" ? true
    : formData.bankDetails.isKuwaitiBankAccount === false && value === "no" ? null
    : formData.bankDetails.isKuwaitiBankAccount === false && value === "no" ? false
    : value === "yes" ? true : value === "no" ? false : null;
 
    setFormData((prevData) => ({
      ...prevData,
      bankDetails: {
        ...prevData.bankDetails,
        isKuwaitiBankAccount: flag,
      },
    })) 
};
const removeBeneficiary = (index: number) => {
  setFormData((prevData) => ({
    ...prevData,
    bankDetails: {
      ...prevData.bankDetails,
      beneficiaries: prevData.bankDetails.beneficiaries.filter(
        (_, i) => i !== index
      ),
    },
  }));
};

const handleFieldChange = (
  index: number,
  field: keyof InvestorBankDetailBeneficiaryModel,
  value: string | number
) => {
  setFormData((prevData) => ({
    ...prevData,
    bankDetails: {
      ...prevData.bankDetails,
      beneficiaries: prevData.bankDetails.beneficiaries.map((family, i) =>
        i === index ? { ...family, [field]: value } : family
      ),
    },
  })); 
  validateBeneficiaries()
};
useEffect(() => { 
  if(!formData.bankDetails.isBehalfOthersInvesting){
    const resetFields =  {
      beneficiaries:[{
        id:0,
        name:'',
        relationshipId:null
        }], 
        actualBeneficiaryFullName:'',
        isKuwaitiBankAccount:null,
        kuwaitiBankId:null,
        bankName:'',
        bankBranchName:'',
        accountNumber:'',
        iban:'',
        other:'', 
      } ;
    setFormData((prevData) => ({
      ...prevData,
      bankDetails: {
        ...prevData.bankDetails, 
        ...resetFields,
      },
    }))
  }
}, [formData.bankDetails.isBehalfOthersInvesting]); 
  
const addBeneficiary = () => {
  setFormData((prevData) => ({
    ...prevData,
    bankDetails: {
      ...prevData.bankDetails,
      beneficiaries: [
        ...prevData.bankDetails.beneficiaries,
        {
          id: 0, 
          name: "",
          relationshipId: null, 
        },
      ],
    },
  }));

  setTouched((prevTouched) => ({
    ...prevTouched,
    beneficiaries: [
      ...prevTouched.beneficiaries || [],
      {
        name: false, 
        relationshipId: false,
      },
    ],
  }));
};
  return ( 
    <Box
    display="flex"
    flexDirection="column"
    gap={2}
    mb={2}
    pl={5}
    sx={{
      textAlign: isRTL ? "right" : "left",
      direction: isRTL ? "rtl" : "ltr", 
      marginRight: '50px', 
    }}
  >
     <Box sx={RegisterStyles.boxStyle}>
        <Grid container item xs={12} spacing={2}>
          <Typography variant="h6" gutterBottom p={1}>
                {t('investingBank')}
          </Typography>
          {touched.investingAccount && (
          <Typography variant="h6" gutterBottom p={1} sx={{ color: theme.palette.error.main }}>
            {t('chooseOneOption') }
          </Typography>
        )}   
          <Grid item xs={12} display="flex" flex={1}>
                <Grid item xs={6}>
                    <FormControlLabel
                        control={
                        <Checkbox
                            style={GeneralStyles.checkBoxStyle}
                            checked={formData.bankDetails.isOwnAccountInvesting || false}
                            onChange={(e: any) => { 
                                setFormData((prevData) => ({
                                  ...prevData,
                                  bankDetails: {
                                    ...prevData.bankDetails,
                                    isOwnAccountInvesting: e.target.checked,
                                    isBehalfOthersInvesting:false
                                  },
                                }))
                            }} 
                        />
                        }
                        label={t('ownAccount')}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormControlLabel
                        control={
                        <Checkbox
                            style={GeneralStyles.checkBoxStyle}
                            checked={formData.bankDetails.isBehalfOthersInvesting || false}
                            onChange={(e: any) => { 
                                const { name, checked } = e.target;
                                setFormData((prevData) => ({
                                  ...prevData,
                                  bankDetails: {
                                    ...prevData.bankDetails,
                                    isOwnAccountInvesting: false,
                                    isBehalfOthersInvesting:e.target.checked
                                  },
                                }))
                            }} 
                        />
                        }
                        label={t('behalfOthers')}
                    />
                </Grid>
          </Grid>
        </Grid>
      </Box> 
      {formData.bankDetails.isBehalfOthersInvesting &&(
         <>
          <Box sx={RegisterStyles.boxStyle}> 
                <Typography variant="h6" gutterBottom p={1}>
                    {t('beneficiaries')}
                </Typography>   
                <Grid container item xs={12} sm={12} spacing={1}>   
                    {formData.bankDetails.beneficiaries.map((item, index) => (
                      <Grid container spacing={2} key={index}>
                        <Grid item xs={12} sm={6} md={6}>
                          <CustomLabeledTextField
                            label={t('name')}
                            isRTL={isRTL}
                            name="name"
                            type="text"
                            required={true}
                            value={item.name}
                            onChange={(e) =>
                              handleFieldChange(index, "name", e.target.value)
                            }
                            error={touched.beneficiaries && touched.beneficiaries[index]?.name || false}
                            helperText={
                              touched.beneficiaries && touched.beneficiaries[index]?.name
                                ? `${t('mandatoryField')}`
                                : ""
                            }
                          />
                        </Grid> 
                        <Grid item xs={12} sm={6} md={5}>
                          <CustomLabeledSelect 
                            label={t('stateOfRelationShip')}
                            isRTL={isRTL}
                            name="relationshipId"
                            type="text"
                            SelectProps={{
                              children: Array.isArray(beneficiaryRelationshipList.data)
                                ? beneficiaryRelationshipList.data.map((item: any) => (
                                    <MenuItem key={item.id} value={item.id}>
                                      {isRTL ? item.valueAr : item.valueEn}
                                    </MenuItem>
                                  ))
                                : null,
                            }}
                            value={item.relationshipId || ""}
                            onChange={(e) =>
                              handleFieldChange(
                                index,
                                "relationshipId",
                                Number(e.target.value) || 0
                              )
                            }
                            multiple={false}
                            required={true}
                            error={
                              touched.beneficiaries && touched.beneficiaries[index]?.relationshipId || false
                            }
                            helperText={
                              touched.beneficiaries && touched.beneficiaries[index]?.relationshipId
                                ? `${t('mandatoryField')}`
                                : ""
                            }
                          />
                        </Grid> 
                        {formData.bankDetails.beneficiaries.length > 1 && (
                          <Grid item xs={12} sm={6} md={1} alignSelf="center">
                            <CustomIcon
                              tooltipText="remove"
                              onClick={() => removeBeneficiary(index)}
                              style={GridStyles.deleteIcon}
                            >
                              <Cancel />
                            </CustomIcon>
                          </Grid>
                        )}
                      </Grid>
                    ))}
                    <CustomIcon
                      tooltipText="add"
                      onClick={addBeneficiary}
                      style={GridStyles.editIcon}
                    >
                      <AddCircle style={{marginLeft:'5px'}} /> {t('addAnother')}
                    </CustomIcon> 
                </Grid>
          </Box> 
          <Box sx={RegisterStyles.boxStyle}>
                <Grid item xs={12} display="flex" flex={1} spacing={1} mb={3}>
                    <Typography variant="body1" sx={RegisterStyles.paragraphStyle} >
                        <b style={{marginLeft:'5px'}}>{t('disclaimer')}:</b> 
                        {t('mandatoryKYCForBeneficiary')}
                    </Typography> 
                </Grid>
                <Grid container item xs={12} spacing={5}>
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('actualBeneficiaryFullName')}
                            isRTL={isRTL}
                            name="actualBeneficiaryFullName"
                            type="text"
                            value={formData.bankDetails.actualBeneficiaryFullName}
                            onChange={(e) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                bankDetails: {
                                  ...prevData.bankDetails,
                                  actualBeneficiaryFullName: e.target.value,
                                },
                              }))
                            }
                            required={true}
                            error={touched.actualBeneficiaryFullName && formData.bankDetails.actualBeneficiaryFullName.trim() === "" && formData.bankDetails.isBehalfOthersInvesting}
                            helperText={
                                touched.actualBeneficiaryFullName && formData.bankDetails.actualBeneficiaryFullName.trim() === "" && formData.bankDetails.isBehalfOthersInvesting
                                ? t('mandatoryField')
                                : ""
                            }
                         />
                    </Grid>
                    <Grid item xs={12} sm={4} p={5}> 
                        <Typography variant="h6" gutterBottom >
                           {t('userBankAccount')}
                            {formData.bankDetails.isKuwaitiBankAccount}
                        </Typography> 
                        <Grid container spacing={2}>
                            <Grid item xs={12}> 
                                 <FormControl component="fieldset">
                                    <RadioGroup
                                        row
                                        value={
                                            formData.bankDetails.isKuwaitiBankAccount === true
                                                ? "yes"
                                                : formData.bankDetails.isKuwaitiBankAccount === false
                                                ? "no"
                                                : "" 
                                        }
                                        name="isKuwaitiBankAccount"
                                    >
                                        <FormControlLabel
                                            value="yes"
                                            control={<Radio style={GeneralStyles.checkBoxStyle} 
                                                        onClick={() => handleRadioClick("yes")}/>}
                                            label={t(`yes`)}
                                            style={{ cursor: "pointer" }}  
                                        />
                                        <FormControlLabel
                                            value="no"
                                            control={<Radio style={GeneralStyles.checkBoxStyle} 
                                            onClick={() => handleRadioClick("no")}/>} 
                                            label={t(`no`)}
                                            style={{ cursor: "pointer" }}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>  
                    <Grid container item xs={12} sm={4} spacing={1}>
                      {formData.bankDetails.isKuwaitiBankAccount === true ?
                        (  
                            <Grid item xs={12} sm={6}>
                                <CustomLabeledSelect
                                    label={t('bankName')}
                                    isRTL={isRTL}
                                    name="kuwaitiBankId"
                                    type="text"
                                    SelectProps={{
                                      children: Array.isArray(banksList.data)
                                        ? banksList.data.map((item: any) => (
                                            <MenuItem key={item.id} value={item.id}>
                                              {item.name}
                                            </MenuItem>
                                          ))
                                        : null,
                                    }}
                                    value={formData.bankDetails.kuwaitiBankId || ""}
                                    onChange={(e) =>
                                      setFormData((prevData) => ({
                                        ...prevData,
                                        bankDetails: {
                                          ...prevData.bankDetails,
                                          kuwaitiBankId: e.target.value as number,
                                        },
                                      }))

                                    }
                                    multiple={false}
                                    required={true} 
                                    error={touched.bankName && formData.bankDetails.kuwaitiBankId === null && formData.bankDetails.isKuwaitiBankAccount === true}
                                    helperText={
                                        touched.bankName && formData.bankDetails.kuwaitiBankId === null && formData.bankDetails.isKuwaitiBankAccount === true
                                        ? t('mandatoryField')
                                        : ""
                                    }
                                />
                            </Grid>   
                        ):
                        (  
                          <Grid item xs={12} sm={6}>
                                <CustomLabeledTextField
                                    label={t('bankName')}
                                    isRTL={isRTL}
                                    name="bankName"
                                    type="text"
                                    value={formData.bankDetails.bankName}
                                    onChange={(e) =>
                                      setFormData((prevData) => ({
                                        ...prevData,
                                        bankDetails: {
                                          ...prevData.bankDetails,
                                          bankName: e.target.value,
                                        },
                                      }))
                                    }
                                    required={true}
                                    error={touched.bankName && formData.bankDetails.bankName.trim() === "" && formData.bankDetails.isKuwaitiBankAccount === false}
                                    helperText={
                                        touched.bankName && formData.bankDetails.bankName.trim() === "" && formData.bankDetails.isKuwaitiBankAccount === false
                                        ? t('mandatoryField')
                                        : ""
                                    }
                                />
                          </Grid> 
                        )
                      } 
                      <Grid item xs={12} sm={6}>
                        <CustomLabeledTextField
                            label={t('branchName')}
                            isRTL={isRTL}
                            name="bankBranchName"
                            type="text"
                            value={formData.bankDetails.bankBranchName}
                            onChange={(e) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                bankDetails: {
                                  ...prevData.bankDetails,
                                  bankBranchName: e.target.value,
                                },
                              }))
                            }
                            required={true}
                            error={touched.bankBranchName && formData.bankDetails.bankBranchName.trim() === ""}
                            helperText={
                                touched.bankBranchName && formData.bankDetails.bankBranchName.trim() === ""
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                      </Grid> 
                    </Grid>
                </Grid>
                <Grid container item xs={12} spacing={5}>
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField
                            label={t('accountNumber')}
                            isRTL={isRTL}
                            name="accountNumber"
                            type="text"
                            value={formData.bankDetails.accountNumber}
                            onChange={(e) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                bankDetails: {
                                  ...prevData.bankDetails,
                                  accountNumber: e.target.value,
                                },
                              }))
                            }
                            required={true} 
                            error={touched.accountNumber && formData.bankDetails.accountNumber.trim() === "" && formData.bankDetails.isKuwaitiBankAccount !== null}
                            helperText={
                                touched.accountNumber && formData.bankDetails.accountNumber.trim() === "" && formData.bankDetails.isKuwaitiBankAccount !== null
                                ? t('mandatoryField')
                                : ""
                            }
                         />
                    </Grid>  
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField
                            label={t('iban')}
                            isRTL={isRTL}
                            name="iban"
                            type="text"
                            value={formData.bankDetails.iban}
                            onChange={(e) =>{
                              setFormData((prevData) => ({
                                ...prevData,
                                bankDetails: {
                                  ...prevData.bankDetails,
                                  iban: e.target.value,
                                },
                              })) 
                                if (ibanIdentifier != "" && !validateKuwaitIBAN(e.target.value, ibanIdentifier)) { 
                                    setTouched((prevData) => ({
                                    ...prevData,
                                    iban: true,
                                    })); 
                                }else{
                                    setTouched((prevData) => ({
                                  ...prevData,
                                  iban: false,
                                  })); 
                                }
                            }}
                            required={true} 
                            error={touched.iban && (formData.bankDetails.isKuwaitiBankAccount !== null && formData.bankDetails.isKuwaitiBankAccount=== true && ((ibanIdentifier != "" && !validateKuwaitIBAN(formData.bankDetails.iban, ibanIdentifier)) || formData.bankDetails.iban.trim() === "" ))}
                            helperText={
                                touched.iban &&(formData.bankDetails.isKuwaitiBankAccount !== null && formData.bankDetails.isKuwaitiBankAccount=== true && ((ibanIdentifier != "" && !validateKuwaitIBAN(formData.bankDetails.iban, ibanIdentifier)) || formData.bankDetails.iban.trim() === "" ))
                                ? t('ibanValidation')
                                : ""
                            }
                         />
                    </Grid>  
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField
                            label={t('other')}
                            isRTL={isRTL}
                            name="other"
                            type="text"
                            value={formData.bankDetails.other}
                            onChange={(e) => 
                            setFormData((prevData) => ({
                              ...prevData,
                              bankDetails: {
                                ...prevData.bankDetails,
                                other: e.target.value,
                              },
                            }))
                            }
                            required={false}  
                         />
                    </Grid>  
                </Grid> 
          </Box>  
        </>
      )} 
    </Box>
  );
}; 

BankDetails.validate = (formData: InvestorModel, confirmPassword?: string, ibanIdentifier?: string): RegisterTouched => {
    const hasBeneficiaryErrors = formData.bankDetails.beneficiaries.every((item) => {
      return (
        item.name.trim() === "" ||
        item.relationshipId === null
      );
    }); 
    const newTouched = {
        investingAccount: !formData.bankDetails.isOwnAccountInvesting && !formData.bankDetails.isBehalfOthersInvesting,  
        actualBeneficiaryFullName: formData.bankDetails.isBehalfOthersInvesting === true && formData.bankDetails.actualBeneficiaryFullName.trim() === "" , 
        isKuwaitiBankAccount: formData.bankDetails.isKuwaitiBankAccount === null , 
        bankBranchName: formData.bankDetails.bankBranchName .trim()==="",  
        bankName: (formData.bankDetails.isKuwaitiBankAccount === false && formData.bankDetails.bankName .trim() === "") || (formData.bankDetails.isKuwaitiBankAccount === true && formData.bankDetails.kuwaitiBankId === null), 
        accountNumber: (formData.bankDetails.isKuwaitiBankAccount !== null && formData.bankDetails.accountNumber .trim() === ""),
        iban: (ibanIdentifier && formData.bankDetails.isKuwaitiBankAccount !== null && formData.bankDetails.isKuwaitiBankAccount=== true && ( ((ibanIdentifier != "" && !validateKuwaitIBAN(formData.bankDetails.iban, ibanIdentifier))) || formData.bankDetails.iban.trim() === "" )) || false,
        beneficiariesFlag: hasBeneficiaryErrors ? true : false,
    }; 
  return newTouched;
}; 


export default BankDetails;
